import { useState } from "react";


export const usePaymentLoginInfoStates = () => {
  // 処理種別 0:口座登録 1:ログイン情報更新
  const [processType, setProcessType] = useState< 0 | 1 >(0);
  const [branchName, setBranchName] = useState("");
  const [loginId1, setLoginId1] = useState("");
  const [loginId2, setLoginId2] = useState("");
  const [loginPwd1, setLoginPwd1] = useState("");
  const [loginPwd2, setLoginPwd2] = useState("");

  const [isActivateConfirmButton, setIsActivateConfirmButton] = useState(false);


  return {
    processType,
    setProcessType,
    branchName,
    setBranchName,
    loginId1,
    setLoginId1,
    loginId2,
    setLoginId2,
    loginPwd1,
    setLoginPwd1,
    loginPwd2,
    setLoginPwd2,
    isActivateConfirmButton,
    setIsActivateConfirmButton,
  };
};
